import { IPeriodOption } from '../../../models/qbr/iQbrQuarter'
import { IMappedPeriodOption } from '../models/mappedPeriod'

export const mapFromPeriodOption = (periodOption: IPeriodOption): IMappedPeriodOption => {
  return {
    fYear: periodOption.FYear,
    isEnabled: periodOption.Enabled === 1,
    fQuarters: periodOption.FQuarters.map((it) => ({
      fQuarter: it.FQuarter,
      isEnabled: it.Enabled === 1,
    })),
  }
}
